export class Node {
	left: Node | null;
	right: Node | null;
	token: string;

	constructor(
		left: Node | null = null,
		right: Node | null = null,
		token: string
	) {
		this.left = left;
		this.right = right;
		this.token = token;
	}
}

export function generateExpressionTree(expr: string[]) {
	const stack: Node[] = [];
	const operators = ["sum", "product"];

	for (let i of expr) {
		if (!operators.includes(i)) {
			const node = new Node(null, null, i);
			stack.push(node);
		} else {
			const right = stack.pop();
			const left = stack.pop();
			if (left && right) {
				const node = new Node(left, right, i);
				stack.push(node);
			}
		}
	}

	return stack.pop();
}

export function preorderExpressionTree(root: Node | null) {
	if (root == null) {
		return;
	}
	preorderExpressionTree(root.left);
	console.log(root.token);
	preorderExpressionTree(root.right);
}

export function referentTypeCheck(
	root: Node | null,
	situationUUID: string,
	argumentMap: Map<string, Map<string, Set<string>>>,
	disableMap: Map<string, boolean>,
	setVal: boolean = false
): boolean {
	if (root!.token === "sum" || root!.token === "token") {
		const left = referentTypeCheck(
			root!.left,
			situationUUID,
			argumentMap,
			disableMap,
			setVal
		);
		const right =
			root!.token === "sum"
				? referentTypeCheck(
						root!.right,
						situationUUID,
						argumentMap,
						disableMap,
						left
				  )
				: referentTypeCheck(
						root!.right,
						situationUUID,
						argumentMap,
						disableMap,
						setVal
				  );

		if (!left && right && root!.token === "sum") {
			referentTypeCheck(
				root!.left,
				situationUUID,
				argumentMap,
				disableMap,
				true
			);
		}

		if (setVal) return true;
		else return root!.token === "sum" ? left || right : false;
	} else {
		if (setVal === true) {
			disableMap.set(root!.token, true);
			return true;
		} else {
			const val = argumentMap.get(situationUUID)?.get(root!.token);

			return val !== undefined && val.size > 0;
		}
	}
}

export function mentionTypeCheck(
	root: Node | null,
	argumentMap: Map<string, Set<string>>,
	disableMap: Map<string, boolean>,
	setVal: boolean = false
): boolean {
	if (root!.token === "sum" || root!.token === "token") {
		const left = mentionTypeCheck(
			root!.left,
			argumentMap,
			disableMap,
			setVal
		);
		const right =
			root!.token === "sum"
				? mentionTypeCheck(root!.right, argumentMap, disableMap, left)
				: mentionTypeCheck(
						root!.right,
						argumentMap,
						disableMap,
						setVal
				  );

		if (!left && right && root!.token === "sum") {
			mentionTypeCheck(root!.left, argumentMap, disableMap, true);
		}

		if (setVal) return true;
		else return root!.token === "sum" ? left || right : false;
	} else {
		if (setVal === true) {
			disableMap.set(root!.token, true);
			return true;
		} else {
			const key = root!.token;
			const val = argumentMap.get(key);

			return val !== undefined && val.size > 0;
		}
	}
}

// export function typeCheck(root:Node|null,map:Map<string,boolean>) : boolean{

//     if(root !== null){

//         if(root.token==="sum" || root.token === "product"){
//             const left = typeCheck(root.left,map);

//             if(left && root.token === "sum"){
//                 setVal(root.right,map,false);
//             }

//             const right = typeCheck(root.right,map);

//             if(right && root.token === "sum"){
//                 setVal(root.left,map,false);
//             }

//         } else{
//             // return (map.has(root.token));
//         }
//     }

//     return true;
// }

// export function setVal(root:Node|null,map:Map<string,boolean>,val:boolean){
//     return true;
// }

// export default {generateExpressionTree, typeCheckRoles};
